module.exports = __webpack_public_path__ + "static/media/comment5_4.dbf6394d.png";